var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('modal-empty',{ref:"thisModal",attrs:{"size":"modal-xs","title":_vm.$t('add_scheduling')}},[_c('div',{staticStyle:{"max-height":"calc(100vh - 270px)","overflow-y":"auto"}},[_c('div',{staticClass:"m-0 p-0"},[_c('add-schedule-selector',{ref:"createScheduleControl",attrs:{"openInPopup":"true"},on:{"event-add-procedureSch":_vm.onSave}})],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9472a5c6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/procedure/procedure-schedule.vue
// module id = 1324
// module chunks = 0